import { ConsentService, GeoveloInlineWhiteIcon } from '@geovelo-frontends/commons';
import { AccountCircle, CookieOutlined, Folder, MenuBook } from '@mui/icons-material';
import { AppBar, Box, Button, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { AppContext } from '../../app/context';
import { environment } from '../../environment';

import ProfileMenu from './profile-menu';

interface IProps {
  openGISFilesDialog: (open: boolean) => void;
}

function Header({ openGISFilesDialog }: IProps): React.JSX.Element {
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState<HTMLButtonElement | null>(null);
  const {
    user: { current: currentUser, partners },
    actions: { openSignInDialog },
  } = useContext(AppContext);
  const { t } = useTranslation();

  return (
    <>
      <AppBar position="relative">
        <Toolbar>
          {environment.config.headerLogo ? (
            <Link key={1} style={{ color: 'inherit', height: 40, textDecoration: 'none' }} to="/">
              <img height={40} src={environment.config.headerLogo} />
            </Link>
          ) : (
            <>
              <Box alignItems="center" display="flex" gap={1}>
                <Box>
                  <Typography component="h1" display="inline-block" key={0} variant="h6">
                    <Link key={1} style={{ color: 'inherit', textDecoration: 'none' }} to="/">
                      <Trans i18nKey="bicycle_facilities.app_title" />
                    </Link>
                  </Typography>
                  <Typography
                    component="span"
                    key={2}
                    style={{ marginLeft: '0.5rem', textTransform: 'lowercase' }}
                  >
                    <Trans i18nKey="commons.by" />
                  </Typography>
                </Box>
                <a
                  href={environment.frontendUrl}
                  rel="noreferrer"
                  style={{ color: 'inherit', height: 24 }}
                  target="_blank"
                >
                  <GeoveloInlineWhiteIcon style={{ height: 24, width: 'auto' }} />
                </a>
              </Box>
            </>
          )}
          <Box flexGrow={1} />
          <Box alignItems="center" display="flex" gap={2}>
            {environment.config.resourceUrl && (
              <Button
                color="inherit"
                href={environment.config.resourceUrl}
                rel="noreferrer"
                size="small"
                startIcon={<MenuBook />}
                target="_blank"
                variant="text"
              >
                Guide
              </Button>
            )}
            {partners && partners.length > 0 && (
              <Button
                color="inherit"
                onClick={() => openGISFilesDialog(true)}
                size="small"
                startIcon={<Folder />}
                variant="outlined"
              >
                <Trans i18nKey="bicycle_facilities.actions.gis_files" />
              </Button>
            )}
            <Tooltip title={<Trans i18nKey="commons.cookies_settings" />}>
              <IconButton
                aria-label={t('commons.cookies_settings')}
                color="inherit"
                onClick={() => ConsentService.openPanel()}
                size="small"
              >
                <CookieOutlined />
              </IconButton>
            </Tooltip>
            {currentUser ? (
              <Tooltip placement="left" title={currentUser.email}>
                <IconButton
                  color="inherit"
                  onClick={({ currentTarget }) => setProfileMenuAnchorEl(currentTarget)}
                  size="small"
                >
                  <AccountCircle />
                </IconButton>
              </Tooltip>
            ) : (
              currentUser === null && (
                <Button
                  color="inherit"
                  onClick={() => openSignInDialog(true)}
                  size="small"
                  variant="outlined"
                >
                  <Trans i18nKey="commons.actions.sign_in" />
                </Button>
              )
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <ProfileMenu anchorEl={profileMenuAnchorEl} onClose={() => setProfileMenuAnchorEl(null)} />
    </>
  );
}

export default Header;
